<template>
  <div class="tab-text w-full">
    <div class="mt-4">
      <div id="user-edit-tab-info">
        <div>
          <div class="vx-row">
            <div class="vx-col w-full mb-base">
              <h2>{{ title }}</h2>
            </div>
          </div>
          <div class="vx-row">
            <div
              class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
              v-for="(section, index) in sections"
              :key="index"
            >
              <statistics-card-line
                :icon="section.icon"
                :statistic="Number(dataSource[section.key])"
                :statisticTitle="section.title"
                :hideChart="!(section.series && section.series.length)"
                :chartData="section.series"
                :color="section.color"
                type="area"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    sections: {},
    dataSource: {},
  },
  components: {
    StatisticsCardLine,
  },
};
</script>
